import cc from 'classcat';
import { useFormikContext, Form } from 'formik';
import { useEffect } from 'react';

import Button from '../../Button';
import { CloudinaryImage } from '../../CloudinaryImage';
import PasswordInputs from '../PasswordInputs';
import Payment from '../Payment';
import SecureCheckoutLabel from '../SecureCheckoutLabel';
import { useMergedStyles } from '../../../hooks';

import localStyles from './styles.module.scss';

export default function QuizCartPaymentAndRegistrationForm({
  children,
  className,
  ctaDisabled,
  ctaLabel,
  isAdHocMembershipOrder,
  order,
  parentStyles,
  pressLogos,
  requiresRegistration,
  savePaymentLabel,
  setBraintreeInstance,
  setPaymentMethodReady,
  theme,
  token,
}) {
  const {
    isSubmitting,
    isValid,
    values: { email, password, passwordConfirmation, storeInVault },
    errors,
  } = useFormikContext();

  const styles = useMergedStyles(localStyles, parentStyles);

  useEffect(() => {
    if (
      passwordConfirmation?.length &&
      !errors.passwordConfirmation &&
      !errors.password
    ) {
      analytics.track('Password Validated', { orderId: order.id });
    }
  }, [errors, passwordConfirmation, order.id]);

  const PasswordInputsHeading = () => (
    <PasswordInputs.DefaultHeading className={styles.passwordHeading}>
      <span>to access your plan</span>
    </PasswordInputs.DefaultHeading>
  );

  const PasswordRules = () => (
    <PasswordInputs.PasswordRules className={styles.passwordRules} />
  );

  const { amountDue, requiresPaymentMethod, requiresStoreInVault } = order;

  return (
    <Form className={cc([styles.container, className])}>
      <div className={styles.section}>
        <h2 className={styles.heading}>Payment Method</h2>
        {requiresPaymentMethod && (
          <Payment
            amountDue={amountDue}
            isAdHocMembershipOrder={isAdHocMembershipOrder}
            requiresStoreInVault={requiresStoreInVault}
            savePaymentLabel={savePaymentLabel}
            setBraintreeInstance={setBraintreeInstance}
            setPaymentMethodReady={setPaymentMethodReady}
            storeInVault={storeInVault}
            parentStyles={parentStyles}
            theme={theme}
            token={token}
          />
        )}

        <SecureCheckoutLabel className={styles.secureCheckout} />
      </div>

      {children && <div className={styles.section}>{children}</div>}

      {pressLogos && (
        <div className={styles.container}>
          <div className={styles.section}>
            <h2 className={styles.pressLogoHeading}>See us featured in</h2>
            <div className={styles.logos}>
              {pressLogos.map((logo, key) => (
                <CloudinaryImage key={key} image={logo} />
              ))}
            </div>
          </div>
        </div>
      )}
      {requiresRegistration && (
        <div className={styles.section}>
          <PasswordInputs
            email={email}
            password={password}
            passwordConfirmation={passwordConfirmation}
            isSubmitting={isSubmitting}
            heading={PasswordInputsHeading}
            rules={PasswordRules}
            className={styles.passwordForm}
          />
        </div>
      )}

      <Button
        theme={theme}
        disabled={ctaDisabled || !isValid || isSubmitting}
        className={styles.cta}
      >
        {ctaLabel}
      </Button>
    </Form>
  );
}
